// Convert hex color to rgb
// e.g. "#ffffff" to RGB string "255,255,255"
export const hexToRgb = (hex: string): string => {
  const parsed = hex?.replace('#', '')
  const bigint = parseInt(parsed, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255
  return `${r},${g},${b}`
}